import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hpcueb3m9: FaireProductEntity = {
  token: "p_3hpcueb3m9",
  type: "product",
  name: "Casual Suit Jacket",
  brandToken: "b_jkhzdth9kx",
  brandName: "Wholesalesir",
  imageUrl:
    "https://cdn.faire.com/fastly/ebc58ceaab1da0429e52fabd1d2965c75c233d57886d7e1cfbcb06c08300092c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/65e407957f8ebaff2467f47f874d2d52aa68234712d03de2ac43e7c0bce7d2d2.jpeg",
    "https://cdn.faire.com/fastly/83e5531665efb44a5121dd7c6a770c0ed7ee7d2520b3f7fdf9591ce7b14fb4e9.jpeg",
    "https://cdn.faire.com/fastly/3accd509c502a61e6ed9f4013850f0b75a37985576877fc1b56b23c584e3bae0.jpeg",
  ],
  priceDollars: 28.93,
  description:
    "100% Polyester,The fabric is soft, skin-friendly and very comfortable and light\nImported\nMachine Wash\nFeatures:High waist,Jacket\n Occasion: Suitable to Wear in Many Occasions, Such as Daily Life, Home, Outing, Vacation, Work, Weekend, Holiday, Casual, Dating, Walk after Supper, Picnic and Any Time in Spring,  Fall \nSize：Please carefully check the size chart before placing an order.Manual measurement of size",
  tags: [],
  msrpDollars: 57.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:34.124Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
